import { registerInventoryListeners } from './inventory';
import { registerMessageListeners } from './message';

export function registerListeners(echo) {

    // 訊息
    registerMessageListeners(echo);

    // 庫存異動
    registerInventoryListeners(echo);
};
